/** @jsx jsx */
import { jsx } from 'theme-ui';
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import 'url-search-params-polyfill'; // for IE
import * as api from '../utils/api';
import HereMap from '../components/HereMap';
import moment from 'moment';
import { useMemo } from 'react';

const FOCUS_POINT_MARKER = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
<circle cx="742" cy="460" r="11" transform="translate(-730 -448)" fill="#001E60" stroke="#FFF" stroke-width="2" fill-rule="evenodd" fill-opacity=".8"/>
</svg>`;
const DELIVERY_POINT_MARKER = `<svg width="34px" height="34px" viewBox="0 0 34 34" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<g id="Icon/Home-Delivery" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="Group-5" fill="#E6F4EE" stroke="#FFFFFF" stroke-width="2">
        <circle id="Oval" cx="17" cy="17" r="16"></circle>
    </g>
    <g id="Icon/express-parcel" transform="translate(4.0158, 7.542)" fill="#001E60" fill-rule="nonzero">
        <path d="M0.0810353243,10.3411733 C0.252545314,10.0024209 0.646016437,9.84991283 0.995050041,9.97096329 L1.08893912,10.0108251 L4.02593912,11.4978251 C4.39548721,11.6849269 4.54338914,12.1361808 4.35628733,12.5057289 C4.18477734,12.8444813 3.79130622,12.9969894 3.44227262,12.8759389 L3.34838354,12.8360771 L0.411383539,11.3490771 C0.041835451,11.1619753 -0.106066482,10.7107214 0.0810353243,10.3411733 Z M0.183009412,6.33786334 C0.362270243,6.0031479 0.759147068,5.85973582 1.10530229,5.98878711 L1.19824909,6.03079919 L4.01024909,7.53679919 C4.37539321,7.73235646 4.51287052,8.18689475 4.31731325,8.55203887 C4.13805241,8.88675431 3.74117559,9.03016639 3.39502037,8.9011151 L3.30207357,8.85910302 L0.490073566,7.35310302 C0.124929446,7.15754575 -0.0125478593,6.70300746 0.183009412,6.33786334 Z M1.39069031,2.98243522 C1.58991206,2.65920223 1.99475269,2.54011275 2.33244814,2.6899108 L2.42267722,2.73748008 L4.11167722,3.77848008 C4.46429502,3.99581291 4.57396517,4.45784918 4.35663235,4.81046699 C4.1574106,5.13369998 3.75256997,5.25278946 3.41487451,5.10299141 L3.32464544,5.05542213 L1.63564544,4.01442213 C1.28302763,3.7970893 1.17335748,3.33505303 1.39069031,2.98243522 Z M16.2324737,0.304114401 L22.4231306,3.46799602 C23.3768459,3.96202704 23.9735148,4.94860778 23.9682232,6.0189511 L23.9682232,12.8944422 C23.9732038,13.9682923 23.3766995,14.9546007 22.4193881,15.4508315 L16.2333349,18.611347 C15.8467278,18.8095603 15.4251712,18.911259 15.0028099,18.916499 C14.9913393,18.9166869 14.9797812,18.9169511 14.9681613,18.9169511 L14.93475,18.9165085 C14.5124007,18.9113866 14.0910807,18.8098089 13.7049345,18.6118315 L7.51416078,15.44889 C6.56059575,14.95488 5.96368824,13.9687662 5.96811582,12.8979511 L5.96811582,6.02224855 C5.96342744,4.94861638 6.55976694,3.96257675 7.51280662,3.4681958 L13.7050001,0.304037183 C14.4986702,-0.101358596 15.4386524,-0.101358596 16.2324737,0.304114401 Z M22.4666529,5.94282042 L19.843,7.282 L19.8431613,9.7359511 C19.8431613,10.1501647 19.5073749,10.4859511 19.0931613,10.4859511 C18.7134656,10.4859511 18.3996704,10.2037972 18.3500079,9.83772166 L18.3431613,9.7359511 L18.343,8.048 L15.718,9.389 L15.718,17.19 L21.7329992,14.1170959 C22.1867078,13.8819051 22.4705871,13.412516 22.468214,12.8979511 L22.468214,6.01522501 C22.4683336,5.99098958 22.467809,5.9668478 22.4666529,5.94282042 Z M7.471,5.943 L7.46812228,6.0189511 L7.46812228,12.901065 C7.46601131,13.4123507 7.75019002,13.8818246 8.20038811,14.1150707 L14.218,17.189 L14.218,9.39 L7.471,5.943 Z M10.842,3.45 L8.366,4.716 L14.9681613,8.0889511 L17.444,6.823 L10.842,3.45 Z M14.38743,1.63981016 L12.49,2.608 L19.092,5.981 L21.569,4.716 L15.5500001,1.63986503 C15.1848775,1.45336546 14.7524451,1.45336546 14.38743,1.63981016 Z" id="Combined-Shape"></path>
    </g>
</g>
</svg>`;

const UPDATE_INTERVAL = 7000;

export const useMapMarker = (HERE, map, position, markerIcon, center, params) => {
  const positionMarker = useRef();
  useEffect(() => {
    if (!position || !map || !HERE) {
      return;
    }
    const coords = {
      lat: position.latitude,
      lng: position.longitude,
    };
    if (positionMarker.current) {
      try {
        map.removeObject(positionMarker.current);
        positionMarker.current = null;
      } catch (e) {
        //Object not on map
      }
    }
    const marker = new HERE.map.Marker(coords, {
      icon: new HERE.map.Icon(markerIcon),
    });
    map.addObject(marker);
    if (center) map.setCenter(coords);
    positionMarker.current = marker;
  }, [map, position, positionMarker]);
};

const Map = ({ shipment: { shipmentNumber, deliveryGuid, deliveryAddress }, token }) => {
  const [error, setError] = useState(null);
  const [position, setPosition] = useState(null);
  const [init, setInit] = useState(false);
  const map = useRef();
  const HERE = useRef();

  const handleGetPosition = useCallback(async () => {
    const response = await api.getDriverPositionForJob(shipmentNumber, token);
    setPosition(response);

    if (map.current && !init) {
      map.current.getViewModel().setLookAtData(
        {
          position: { lat: response.latitude, lng: response.longitude },
          zoom: 12,
        },
        false
      );
      setInit(true);
    }
  }, [deliveryGuid, setPosition, map, init]);

  useEffect(() => {
    handleGetPosition().catch(setError);
    const interval = setInterval(() => handleGetPosition().catch(setError), UPDATE_INTERVAL);
    return () => {
      clearInterval(interval);
    };
  }, [handleGetPosition, setError]);

  const [addressPosition, setAddressPosition] = useState();

  useMapMarker(HERE.current, map.current, addressPosition, FOCUS_POINT_MARKER, true, {
    anchor: { x: 10, y: 10 },
    size: { w: 20, h: 20 },
  });
  useMapMarker(HERE.current, map.current, position, DELIVERY_POINT_MARKER, false, {
    anchor: { x: 15, y: 13 },
    size: { w: 30, h: 26 },
  });

  const handleMapCreated = useCallback(
    (newMap, platform, newHERE) => {
      map.current = newMap;
      HERE.current = newHERE;
      if (!addressPosition) {
        const geocoder = platform.getGeocodingService();
        geocoder.geocode(
          {
            searchText: deliveryAddress,
            maxresults: 1,
          },
          (result) => {
            const position = result.Response.View[0].Result[0].Location.DisplayPosition;
            setAddressPosition({
              latitude: position.Latitude,
              longitude: position.Longitude,
            });
          },
          (e) => console.warn('searchAddressByCoordinates failed:', e)
        );
      }
    },
    [setAddressPosition, deliveryAddress, map]
  );
  return (
    <div>
      {error && process.env.GATSBY_ACTIVE_ENV !== 'production' && <p>{error.toString()}</p>}
      <HereMap onMapCreated={handleMapCreated} height={80} paddingLeft={0} />
    </div>
  );
};

export const MapDelivery = ({ shipment, token, goNext }) => {
  const {
    sender,
    deliveryTime: { deliveryApproximateTime },
    estimatedDeliveryStartTime,
    estimatedDeliveryEndTime,
  } = shipment;

  const [startTime, endTime] = useMemo(() => {
    return [
      moment(estimatedDeliveryStartTime).tz('Europe/Helsinki'),
      moment(estimatedDeliveryEndTime).tz('Europe/Helsinki'),
    ];
  }, [estimatedDeliveryStartTime, estimatedDeliveryEndTime]);

  const [timeNow, setTimeNow] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => setTimeNow(Date.now()), 1000);
    return () => clearInterval(interval);
  }, []);

  const minutes = useMemo(() => {
    return Math.round((deliveryApproximateTime - timeNow) / 60000);
  }, [timeNow, deliveryApproximateTime]);

  const { t: translate } = useTranslation();

  return (
    <div sx={{ mb: 3 }}>
      {deliveryApproximateTime && (
        <>
          <p>
            {translate('delivery.agree.incoming', {
              sender,
              shipmentNumber: shipment.shipmentNumber,
            })}
          </p>
          <p>
            {translate('delivery.agree.parcelIncomingSoon', {
              start: startTime?.format('HH:mm'),
              end: endTime?.format('HH:mm'),
            })}
          </p>
        </>
      )}
      <Map shipment={shipment} token={token} />
    </div>
  );
};
